/**
 * method of notification for an actionItem subscription
 */
export enum ActionItemSubscriptionNotificationMethod {
  Email = 'EMAIL',
  Slack = 'SLACK',
}
